import { BUY_TOUCHLESS, TALK_TO_SALES, TRIAL } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { useAppSelector } from '../../../reducers';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
import { purchaseMotionsSelector } from '../../../selectors/PurchaseMotionSelectors';
export const useHubPurchaseMotions = ({
  skuId
}) => {
  const isAppReady = useGlobalLoading();
  const purchaseMotions = useAppSelector(state => {
    if (!isAppReady || !skuId) return [];
    return purchaseMotionsSelector(state, {
      skuId
    });
  });
  const isAppAuth = useAppSelector(isAppAuthSelector);
  if (isAppAuth) {
    return purchaseMotions;
  }
  if (purchaseMotions.includes(TRIAL)) return purchaseMotions;
  if (purchaseMotions.includes(BUY_TOUCHLESS)) return [BUY_TOUCHLESS];
  return [TALK_TO_SALES];
};